import Events from '@/components/ezuro/schedule/report/Events.vue'
import Teams from '@/components/ezuro/schedule/report/Teams.vue'

export default {
  name: 'ScheduleReportWrap',
  components: {
    Events,
    Teams
  },
  computed: {
    tabOptions () {
      return [
        { code: 'Events', text: this.$t('work-schedule.events'), slotcode: 'Events' },
        { code: 'Teams', text: this.$t('menu.constants.teams'), slotcode: 'Teams' }
      ]
    }
  },
  methods: {
    tabChanged (el) {
      if (this.tabOptions[el]) {
        this.activeTab = this.tabOptions[el].code;
      }
    }
  }
}
